import { FC } from 'react';

import checkIcon from 'assets/images/checkIcon.svg';

import color from 'atoms/colors/colors';
import { fontSize, lineHeight } from 'atoms/typography/typography';

import Flex from 'quarks/Flex';

import Section from 'molecules/Section/Section';

import TableOfContents from 'components/ResourceDetailLayout/components/Sidebar/TableOfContents';

import richTextParser from 'utils/richTextParser';

import type {
  ContentfulComponentSingleInstance,
  ContentfulComponentSingleInstanceTableOfContentsJsonNode,
} from 'graphqlTypes';

type BlogDetailProps = ContentfulComponentSingleInstance;

const bodyCSS = `
  word-wrap: break-word;
  p {
    color: ${color.gray[900]};
  }
  h1, h2, h3, h4, h5, h6 {
    color: ${color.gray[900]};
  }
  h2 {
    font-size: ${fontSize.h4};
    line-height: ${lineHeight.h4};
  }
  h2 {
    font-size: ${fontSize.h5};
    line-height: ${lineHeight.h5};
  }
  h3 {
    font-size: ${fontSize.h6};
    line-height: ${lineHeight.h6};
  }
  h4 {
    font-size: ${fontSize.textLg};
    line-height: ${lineHeight.textLg};
  }
  h5, h6 {
    font-size: ${fontSize.textMd};
    line-height: ${lineHeight.textMd};
  }
  ul {
    li {
      padding-left: 30px;
      &:before {
        background-image: url(${checkIcon});
        background-color: ${color.common.transparent};
        background-position: center;
        background-repeat: no-repeat;
        background-size: 100%;
        width: 20px;
        height: 20px;
        content: '';
        position: absolute;
        top: 4px;
        left: 0;
      }
    }
  }
`;

const BlogDetail: FC<BlogDetailProps> = ({ id, body, tableOfContents }) => {
  const showToc = tableOfContents && tableOfContents.filter(x => x?.content?.[0]?.isVisible).length > 0;

  return (
    <>
      <Section id={id} paddingBottomDesktop="48" paddingBottomTablet="48" paddingBottomMobile="48">
        <Flex
          flexDirection="column-reverse"
          justifyContent="space-between"
          width="100%"
          gap="32px"
          lg={{ flexDirection: 'row' }}
        >
          <Flex
            flexDirection="column"
            width="100%"
            maxWidth="100%"
            gap="24px"
            lg={{ maxWidth: showToc ? '770px' : '100%' }}
          >
            {body && (
              <Flex flexDirection="column" gap="30px" width="100%" css={bodyCSS}>
                {richTextParser(body)}
              </Flex>
            )}
          </Flex>
          {showToc && (
            <Flex
              width="100%"
              maxWidth="100%"
              height="fit-content"
              flexDirection="column"
              position="relative"
              gap="32px"
              lg={{ position: 'sticky', top: '100px', maxWidth: '300px' }}
            >
              <TableOfContents
                tableOfContents={tableOfContents as ContentfulComponentSingleInstanceTableOfContentsJsonNode[]}
              />
            </Flex>
          )}
        </Flex>
      </Section>
      <Flex
        width="100%"
        height="100%"
        maxHeight="32px"
        position="absolute"
        top="0"
        left="0"
        backgroundColor="navy-900"
        md={{ maxHeight: '56px' }}
        lg={{ maxHeight: '96px' }}
        css={`
          clip-path: polygon(0% 50%, 0% 100%, 100% 0%, 100% 0%, 0% 0%);
        `}
      />
    </>
  );
};

export default BlogDetail;
